var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image"},[_c('viewer',{ref:"viewer",staticClass:"viewer",attrs:{"options":_vm.options},on:{"inited":_vm.inited}},[[_c('img',{staticClass:"max-width-100",attrs:{"src":_vm.stringSource}})]],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }